import { render } from "./NewAppealModal.vue?vue&type=template&id=b365b768&scoped=true"
import script from "./NewAppealModal.vue?vue&type=script&lang=js"
export * from "./NewAppealModal.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-b365b768"

export default script